<template>
  <div class="main-width">
    <div class="about-des">
      <div>
        <b><i>MELO</i></b> was unique in <b>(<i>a</i>)</b> enabling
        comprehensive measurement by collectively considering changes in
        <i>Geometric  Characteristics</i> and <i>Relative Distances</i> among amino acids,
        <b>(<i>b</i>)</b> realizing high-throughput location of structure
        alterations by simultaneously assessing the variations of secondary
        structures and the shifts among protein segments.
      </div>
      <br />


      <el-carousel
        :autoplay="!dialogTip"
        ref="carousel"
        :interval="2000"
        arrow="always"
        height="500px"
        type="card"
        @change="handleCarouselChange"
      >
        <el-carousel-item
          v-for="(image, index) in images"
          :key="index"
          :name="`${index + 1}`"
        >
          <div class="zmd-div">
            <img
              @click="dialogTip = true"
              :src="`${domain}/files/home-pic/${image.src}`"
              style="display: initial; width: 420px"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div>


      <!-- <el-tabs v-model="currentImageIndex">
        <el-tab-pane label="Figure 1" name="1">
          <HomeLegend :figureIndex="'1'"></HomeLegend>
        </el-tab-pane>
        <el-tab-pane label="Figure 2" name="2">
          <HomeLegend :figureIndex="'2'"></HomeLegend>
        </el-tab-pane>
        <el-tab-pane label="Figure 3" name="3">
          <HomeLegend :figureIndex="'3'"></HomeLegend>
        </el-tab-pane>
        <el-tab-pane label="Figure 4" name="4">
          <HomeLegend :figureIndex="'4'"></HomeLegend>
        </el-tab-pane>
        <el-tab-pane label="Figure 5" name="5">
          <HomeLegend :figureIndex="'5'"></HomeLegend>
        </el-tab-pane>
        <el-tab-pane label="Figure 6" name="6">
          <HomeLegend :figureIndex="'6'"></HomeLegend>
        </el-tab-pane>
        <el-tab-pane label="Figure 7" name="7">
          <HomeLegend :figureIndex="'7'"></HomeLegend>
        </el-tab-pane>
      </el-tabs> -->
    </div>
    <div style="">
      <el-dialog
        :title="`Description of the Figure`"
        :visible.sync="dialogTip"
      >
        <div >
          <div style="text-align: center">
            <img
            @click="dialogTip = true"
            :src="`${domain}/files/home-pic/image${currentImageIndex}.png`"
            style="display: initial; width: 70%"
          />
          </div>
          

          <br />

          <HomeLegend :figureIndex="currentImageIndex"></HomeLegend>
          <div></div>
        </div>
      </el-dialog>
    </div>
    <br />
    <br />
    <AssessmentPage :pageName="'HomeView'"></AssessmentPage>
    <SearchPage :pageName="'HomeView'"></SearchPage>
  </div>
</template>

<script>
import pathUrl from "@/api/path";
import HomeLegend from "@/components/new/home-legend.vue";
import AssessmentPage from "@/views/newViews/AssessmentPageNew.vue";
import SearchPage from "@/views/SearchPage.vue";
export default {
  name: "HomeView",
  data() {
    return {
      domain: pathUrl.localUrl,
      dialogTip: false,
      currentImageIndex: "1",
      images: [
        { src: "image1.png" },
        { src: "image2.png" },
        { src: "image3.png" },
        { src: "image4.png" },
        { src: "image5.png" },
        { src: "image6.png" },
        { src: "image7.png" },
        { src: "image8.png" },

      ],
    };
  },
  components: {
    HomeLegend,
    AssessmentPage,
    SearchPage,
  },
  watch: {
    currentImageIndex: {
      handler: function (o) {
        this.goToSlide(o);
      },
      deep: true,
    },
  },
  methods: {
    handleCarouselChange(newIndex) {
      newIndex = (newIndex + 1).toString();
      if (this.currentImageIndex != newIndex) {
        this.currentImageIndex = newIndex;
      }

      // this.currentImageIndex = newIndex;
    },
    goToSlide(slide) {
      const currentIndex = this.$refs.carousel.activeIndex + 1;
      if (parseInt(slide, 10) !== currentIndex) {
        this.$refs.carousel.setActiveItem(slide);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.about-des {
  text-align: justify;
  background: #fafafa;
  margin: 0 auto;
  border: 1px solid #9e9e9e;
  padding: 22px;
  border-radius: 5px;
  margin-top: 30px;
  box-shadow: 3px 2px 2px 2px #cbcaca;
}
.zmd-div {
  background-color: #fff;
  text-align: center;
}
.el-carousel__item:nth-child(2n) {
  background-color: #fff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #fff;
}
/deep/.page-title {
  display: none !important;
}
</style>
